document.addEventListener('DOMContentLoaded', () => {
	const categoryLinks = document.querySelectorAll('.category-menu li a');
  
	// Check if we're in Shopify theme editor
	const isThemeEditor = window.Shopify && Shopify.designMode;
  
	// Set cookie
	const setCookie = (name, value, days) => {
	  const expires = days
		? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}`
		: '';
	  document.cookie = `${name}=${value}; path=/${expires}`;
	};
  
	// Get cookie
	const getCookie = name =>
	  document.cookie
		.split(';')
		.map(c => c.trim())
		.find(c => c.startsWith(name + '='))?.substring(name.length + 1) || null;
  
	// Helper functions to save and load the category from the proper storage
	const saveCategory = category => {
	  if (isThemeEditor) {
		localStorage.setItem('selectedCategory', category);
	  } else {
		setCookie('selectedCategory', category, 30);
	  }
	};
  
	const loadCategory = () =>
	  isThemeEditor ? localStorage.getItem('selectedCategory') : getCookie('selectedCategory');
  
  
	/* HIGHLIGHT TOP MENU */
	const highlightSecondaryMenu = selectedCategory => {
	  categoryLinks.forEach(item => {
		item.classList.toggle('is-active', item.getAttribute('data-category') === selectedCategory);
	  });
	};
  
	/**
	 * Shows/hides sub-category menus based on the selected category.
	 * Also adapts display ('flex' vs 'block') for desktop/mobile.
	 */
	function updateSubCategoryDisplay(selectedCategory) {
	  // Determine layout type based on viewport width
	  const isMobile = window.matchMedia('(max-width: 768px)').matches;
	  const displayType = isMobile ? 'block' : 'flex';
  
	  document.querySelectorAll('.sub-category-menu').forEach((group) => {
		const groupCategory = group.getAttribute('data-category');
  
		// Use == for type coercion, matching original logic (e.g., "5" == 5)
		if (groupCategory == selectedCategory) {
		  group.style.visibility = 'visible';
		  group.style.opacity = '1'; // Fade in
		  group.style.display = displayType;
		} else {
		  group.style.opacity = '0'; // Fade out
		  group.style.display = 'none';
		}
	  });
	}
  
	// Consolidated function to update the category (used for initial load)
	const updateCategory = selectedCategory => {
	  if (!selectedCategory) return;
	  saveCategory(selectedCategory);
	  updateSubCategoryDisplay(selectedCategory);
	  highlightSecondaryMenu(selectedCategory);
	};
  
	// --- Initial Category Load Logic ---
	let savedCategory = loadCategory();
  
	if (typeof window.productClass === 'string') {
	  savedCategory = window.productClass === 'Miehet' ? 'miehet' : window.productClass === 'Lapset' ? 'lapset' : 'naiset';
	  saveCategory(savedCategory);
	}
  
	if (!savedCategory && categoryLinks.length) {
	  savedCategory = categoryLinks[0].getAttribute('data-category');
	  saveCategory(savedCategory);
	}
  
	if (savedCategory) {
	  updateCategory(savedCategory);
	}
  
	// --- Click Listeners for Category Links ---
	categoryLinks.forEach(categoryLink => {
	  categoryLink.addEventListener('click', event => {
		const selectedCategory = categoryLink.getAttribute('data-category');
		if (!selectedCategory) return;
		
		// --- MODIFICATION ---
		// Always save the category and update the top link highlighting
		saveCategory(selectedCategory);
		highlightSecondaryMenu(selectedCategory);
  
		// Only run the sub-category display logic on mobile
		const isMobile = window.matchMedia('(max-width: 768px)').matches;
		if (isMobile) {
		  updateSubCategoryDisplay(selectedCategory);
		}
		// --- END MODIFICATION ---
  
		if (categoryLink.getAttribute('href') === '#') {
		  event.preventDefault();
		}
	  });
	});
  
	// --- Mobile Link Prevention & Resize Handling ---
  
	// Handler to prevent default link behavior
	function preventLink(e) {
	  e.preventDefault();
	}
  
	// Adds or removes the 'preventLink' listener based on viewport size
	function manageMobileLinkPrevention() {
	  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  
	  categoryLinks.forEach(link => {
		if (isMobile) {
		  link.addEventListener('click', preventLink, { passive: false });
		} else {
		  link.removeEventListener('click', preventLink);
		}
	  });
	}
  
	// Single handler for all resize-related logic
	const onResize = () => {
	  manageMobileLinkPrevention();
	  // Re-run display logic to update 'display: flex' vs 'display: block'
	  updateSubCategoryDisplay(loadCategory());
	};
  
	// Run link prevention logic once on load
	window.addEventListener('load', manageMobileLinkPrevention);
	// Run all resize logic
	window.addEventListener('resize', onResize);
  });